import { useClient } from '@composables/use-clients';
import {
  GetRequestArgsType,
} from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type GetAssessmentArgsType = GetRequestArgsType & {
  assessmentId: number;
};

export const apiFetchAssessments = async ({
  domain = useTenantStore().domain,
  query = {},
  errorConfig = {},
  callbacks = {},
}: GetRequestArgsType = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.assessments({ domain }),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiFetchAssessment = async ({
  domain = useTenantStore().domain,
  assessmentId,
  errorConfig = {},
  callbacks = {},
}: GetAssessmentArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.assessments({ domain, assessmentId }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
